import { Component, computed, OnInit, signal, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { PrimaryButtonComponent } from '../../../../../shared/components/primary-button/primary-button.component';
import { SecondaryButtonComponent } from '../../../../../shared/components/secondary-button/secondary-button.component';
import { FormControl, FormsModule } from '@angular/forms';
import { Filter } from '../../models/HRISIntegrationDTO';
import { MatDialogRef } from '@angular/material/dialog';
import { MatCheckbox } from '@angular/material/checkbox';
import { HrisIntegrationDataService } from '../../services/hris-integration-data.service';
import { InputFieldComponent } from '../../../../../shared/components/input-field/input-field.component';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-hris-integration-filters-dialog',
  imports: [
    MatIcon,
    TranslocoPipe,
    PrimaryButtonComponent,
    SecondaryButtonComponent,
    FormsModule,
    MatCheckbox,
    InputFieldComponent,
  ],
  templateUrl: './hris-integration-filters-dialog.component.html',
})
export class HrisIntegrationFiltersDialogComponent implements OnInit {
  dialogRef =
    inject<MatDialogRef<HrisIntegrationFiltersDialogComponent>>(MatDialogRef);
  protected readonly hrisIntegrationDataService = inject(
    HrisIntegrationDataService,
  );

  readonly searchControl = new FormControl('', { nonNullable: true });

  filters = signal<Filter[]>([]);

  search = toSignal(this.searchControl.valueChanges, {
    initialValue: this.searchControl.value,
  });

  filtersToDisplay = computed<Filter[]>(() => {
    const query = this.search().trim().toLowerCase();

    return [...this.filters()]
      .sort(
        (a, b) =>
          Number(b.selected) - Number(a.selected) ||
          a.name.localeCompare(b.name),
      )
      .filter((f) => f.name.toLowerCase().includes(query));
  });

  ngOnInit() {
    this.setFilters();
  }

  setFilters() {
    if (this.hrisIntegrationDataService.hrisIntegration?.filters) {
      this.filters.set(this.hrisIntegrationDataService.hrisIntegration.filters);
    }
  }

  toggleFilter(id: string) {
    this.filters.update((fs) =>
      fs.map((f) => (f.id === id ? { ...f, selected: !f.selected } : f)),
    );
  }

  getSelectedCount(filters: Filter[]) {
    return filters.filter((filter) => filter.selected).length;
  }

  onCancelButtonClicked() {
    this.setFilters();
    this.dialogRef.close();
  }

  onSaveButtonClicked() {
    this.hrisIntegrationDataService.saveFilters(this.filters());
    this.dialogRef.close();
  }
}
